/*
 * Copyright (c) 2023. Data Smart Technologies CC
 * https://www.datasmart.co.za
 * View license agreement and terms of use at https://www.datasmart.co.za/legal
 *
 * @author  Juan <juan@datasmart.co.za>
 * @version 1.0
 * @updated 2023-07-11
 */

import React, { useEffect, useState } from "react";
import { SpinnerLoading } from "../utils/SpinnerLoading";
import { ErrorMessage } from "../utils/ErrorMessage";
import { baseUrl, fetchRecords } from "../utils/AppUtil";
import { Link } from "react-router-dom";

class ProfilePicture {
    deceasedId: string;
    deceased: string;
    pictureUploadedDateDisplay: string;
    constructor(deceasedId: string, deceased: string, pictureUploadedDateDisplay: string) {
        this.deceasedId = deceasedId;
        this.deceased = deceased;
        this.pictureUploadedDateDisplay = pictureUploadedDateDisplay
    }
}

type RecentProfilePicturesProps = {
    pictureType: string;
    endpoint: string;
    recordCount: number;
}

export const RecentProfilePictures: React.FC<RecentProfilePicturesProps> = (props): JSX.Element => {
    
    const [records, setRecords] = useState<ProfilePicture[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const [httpError, setHttpError] = useState(null);
    const [endpoint, setEndpoint] = useState(`${props.endpoint}?pictureType=${props.pictureType}&count=${props.recordCount}`);

    // Do not change this or put any additional code in here without checking with
    // the team first.
    useEffect(() => {

        fetchRecords(endpoint, processData)
        .catch((error) => {
            setIsLoading(false);
            setHttpError(error.message);
        });

    }, [endpoint]);

    // You may edit this function to manipulate the way your code is processed.
    const processData = (responseJson: any) => { // Do not edit these parameters, just the content of this function.
        const recordData: ProfilePicture[] = [];
    
        setIsLoading(true);
        for(const key in responseJson) {
            const record: any = responseJson[key];
            const deceasedId = record["deceasedId"];

            let deceased: string = (record["deceasedFirstName"] ? record["deceasedFirstName"] : "") + " " + (record["deceasedLastName"] ? record["deceasedLastName"] : "");
            if(!record["deceasedId"]) {
                deceased = "Not Specified";
            }

            const pictureUploadedDateDisplay: string = record["pictureUploadedDateDisplay"];

            recordData.push(new ProfilePicture(deceasedId, deceased, pictureUploadedDateDisplay));
            
        }
        setRecords(recordData);
        setIsLoading(false);
    }

    if(isLoading) {
        return(
            <SpinnerLoading />
        )
    }

    if(httpError) {
        return(
            <ErrorMessage error={httpError} />
        )
    }

    const result: React.ReactElement[] = [];

    records.forEach((profilePicture, index) => {

        const profileImagePath: string = `${baseUrl}/image/deceased/${profilePicture.deceasedId}/profile`;
        
        result.push(
            <tr key={index}>
                <td className="jc-txt-body fs-6 fw-bold pe-0">
                    <Link to={'/deceased/' + profilePicture.deceasedId} className="d-flex gap-3 align-items-center jc-txt-blue">
                        <div className="recent-image-wrapper">
                            <img src={profileImagePath} className="recent-image" />
                        </div>
                        {profilePicture.deceased}
                    </Link>
                </td>
                <td className="jc-txt-body fs-6 align-end ps-0" style={{whiteSpace: "nowrap"}}>{profilePicture.pictureUploadedDateDisplay}</td>
            </tr>
        )
    });
    
    return (
        <div className="card jc-border-12">
            <div className="card-header card-header-bg">
                <p className="jc-txt-heading fs-5">Recent Profile Pictures</p>
            </div>

            <div className="card-body p-0">
                <div className="table-profile-pics">
                    <table className="table table-striped mb-0">
                        <tbody>
                            {result}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}